import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../types'
import { UserNotification } from './types'
import { LoadingState } from '../types'

const selectNotifications = (state: RootState) => state.notifications

export const selectNotificationsList = createSelector(
  selectNotifications,
  (state) => state.notifications
)

export const selectNotificationsLoadingState = createSelector(
  selectNotifications,
  (state) => state.loadingState
)

export const selectNotificationsError = createSelector(
  selectNotifications,
  (state) => state.error
)

export const selectUnreadCount = createSelector(
  selectNotifications,
  (state) => state.unreadCount
)

export const selectUnreadNotifications = createSelector(
  selectNotifications,
  (state) =>
    state.notifications.filter(
      (notification: UserNotification) => !notification.reviewed
    )
)

export const selectReviewedNotifications = createSelector(
  selectNotifications,
  (state) =>
    state.notifications.filter(
      (notification: UserNotification) => notification.reviewed
    )
)

export const selectNotificationsByType = createSelector(
  [
    selectNotificationsList,
    (state: RootState, notificationType: number) => notificationType,
  ],
  (notifications, type) =>
    notifications.filter(
      (notification: UserNotification) => notification.notificationType === type
    )
)

export const selectHasUnreadNotifications = createSelector(
  selectUnreadCount,
  (count) => count > 0
)

export const selectIsNotificationsLoading = createSelector(
  selectNotificationsLoadingState,
  (loadingState) => loadingState === LoadingState.LOADING
)

export const selectBundleNotifications = createSelector(
  [selectNotificationsList],
  (notifications: UserNotification[]) =>
    notifications.filter(() => true) //notification.isBundle === true || notification.shouldOpenBundle === true
)

export const selectHasBundleNotifications = createSelector(
  [selectNotificationsList],
  (notifications: UserNotification[]) =>
    notifications.some(() => true)
)

export const selectUnreadBundleNotifications = createSelector(
  [selectNotificationsList],
  (notifications: UserNotification[]) =>
    notifications.filter(() => true)
)

export const selectIsBundleDrawerOpen = createSelector(
  selectNotifications,
  (state) => state.isBundleDrawerOpen
)
